export default {"src":"/_next/static/media/react.512a3a7e.svg","height":228,"width":256,"blurWidth":0,"blurHeight":0};